import getSymbolFromCurrency from "currency-symbol-map";
import React from "react";

import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  CartesianAxis,
  ResponsiveContainer,
} from "recharts";

const width = 3200;
const height = 306;
const yAxisWidth = 40;

const AreaChartComponent = ({data, filter}) => {
  const verticalGrid = [];
  for (let i = yAxisWidth; i <= width; i += 20) {
    verticalGrid.push(i);
  }

  return (
    <ResponsiveContainer height={height}>
      <AreaChart
        data={data}
        margin={{
          top: 0,
          right: 20,
          left: 0,
          bottom: 0,
        }}
      >
        <defs>
          <linearGradient id="colorGold" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#F0D800" stopOpacity={0.3} />
            <stop offset="95%" stopColor="#F0D800" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="colorSilver" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#B3B3B3" stopOpacity={0.3} />
            <stop offset="95%" stopColor="#B3B3B3" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="colorBronze" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#C87800" stopOpacity={0.3} />
            <stop offset="95%" stopColor="#C87800" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid
          opacity={0.5}
          horizontal={false}
          verticalPoints={verticalGrid}
        />
        <CartesianAxis />
        <XAxis
          tickMargin={20}
          tickSize={0}
          axisLine={false}
          dataKey={filter}
          style={{ fill: "black", fontSize: "0.625rem", fontWeight: 300 }}
        />
        <YAxis
          tickMargin={10}
          axisLine={true}
          tickSize={0}
          tickCount={8}
          unit={getSymbolFromCurrency('USD')}
          minTickGap={1}
          domain={[0, (dataMax) => dataMax + 4]}
          width={yAxisWidth}
          style={{ fill: "black", fontSize: "0.625rem", fontWeight: 300 }}
        />
        <Tooltip cursor={false} />
        <Area
          type="bumpX"
          dataKey="Gold"
          stroke="#F0D800"
          strokeWidth={4}
          fill="url(#colorGold)"
        />

        <Area
          type="bumpX"
          dataKey="Silver"
          stroke="#B3B3B3"
          strokeWidth={4}
          fill="url(#colorSilver)"
        />

        <Area
          type="bumpX"
          dataKey="Bronze"
          stroke="#C87800"
          strokeWidth={4}
          fill="url(#colorBronze)"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default AreaChartComponent;
